import { render, staticRenderFns } from "./HorseTable.vue?vue&type=template&id=8be18948&"
import script from "./HorseTable.vue?vue&type=script&lang=js&"
export * from "./HorseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports